var _defs, _path, _path2, _path3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyMeterSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#465165;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M442.4,80.2H162.1c-41.8,0-75.9,34-75.9,75.9V422.6c0,40.1,31.2,73,70.6,75.7-.1,.9-.2,1.9-.2,2.9v3.3c0,10.4,8.5,18.9,18.9,18.9H435.7c10.4,0,18.9-8.5,18.9-18.9v-3.3c0-1.2-.1-2.4-.4-3.6,36.2-5.7,64-37.1,64-74.9V156.1c0-41.8-34-75.9-75.9-75.9Zm56.9,342.4c0,31.4-25.5,56.9-56.9,56.9H162.1c-31.4,0-56.9-25.5-56.9-56.9V156.1c0-31.4,25.5-56.9,56.9-56.9H442.4c31.4,0,56.9,25.5,56.9,56.9V422.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.1,214.8H472.1v-83.6H136.1v83.6Zm211.6-18.6h-35v-46.5h35v46.5Zm17.6-46.5h35v46.5h-35v-46.5Zm-70.2,46.5h-35v-46.5h35v46.5Zm-52.6,0h-35v-46.5h35v46.5Zm210.9,0h-35.6v-46.5h35.6v46.5Zm-298.8-46.5h35.4v46.5h-35.4v-46.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.9,451.9H469.2v-44.5H138.9v44.5Zm12.9-31.5H456.3v18.6H151.8v-18.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "259.8 327.7 300.2 327.7 270.6 396.5 340.2 310.6 299.5 310.6 329.4 241.8 259.8 327.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyMeterSymbol);
export default __webpack_public_path__ + "static/media/energy-meter-symbol.61076de23c51ee5ce91683ba5150f9d1.svg";
export { ForwardRef as ReactComponent };